import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../../baseQuery/basePharmaNavigatorQuery';

const BASE_PREFIX = '/api/v1/activity';

export const activityApi = createApi({
    reducerPath: 'activityApi',
    baseQuery,
    tagTypes: ['activity'],
    endpoints: (builder) => ({
        loginActivity: builder.mutation<void, void>({
            query: () => ({
                url: `${BASE_PREFIX}/login`,
                method: 'POST',
            }),
        }),
        logoutActivity: builder.mutation<void, void>({
            query: () => ({
                url: `${BASE_PREFIX}/logout`,
                method: 'POST',
            }),
        }),
        pageOpenActivity: builder.mutation<void, { url: string }>({
            query: ({ url }) => ({
                url: `${BASE_PREFIX}/page/open`,
                method: 'POST',
                body: {
                    url,
                },
            }),
        }),
    }),
});

export const { useLoginActivityMutation, useLogoutActivityMutation, usePageOpenActivityMutation } = activityApi;
